import { catalogInsertable, composeProductInsert, mediaInsertable, type CatalogInsertable, type CatalogMedia, type CatalogProduct, type MediaInsertable } from "./catalog";

/**
 * X3 RAIL: the catalog contract the rail codes against.
 *
 * X integration 2b: X2 CATALOG is picked, so every body here is a call to X2's
 * function in core/catalog.ts, and X2's refusal names are the contract
 * (`CatalogRefusal`: sold, unavailable, unknown_availability, stale, no_price,
 * offer_wording, in that order; `MediaRefusal`: rights_mismatch,
 * other_contacts_media, stale). Nothing is decided here. The rail-prefixed
 * names stay so the rail's callers (railInserts.ts, rail.ts, railPrefill.ts,
 * railSources.ts) keep one import each, and so the media check here REQUIRES
 * `now`: X2's `mediaInsertable` skips the staleness check without one, and no
 * rail caller may skip it.
 *
 * Offer wording (CLAUDE.md section 0.5) is X2's `offer_wording`, read by core's
 * one reader `holdsOfferWording` (offerWords.ts) over the name, the description
 * and the decoded link. Never a second word list.
 */

/** The product fields the rail reads: X2's `CatalogProduct`, narrowed. */
export type RailProductRecord = Pick<CatalogProduct, "id" | "version" | "name" | "priceCents" | "availability" | "url" | "fetchedAt" | "ttlSeconds">;

export function railCatalogInsertable(p: RailProductRecord, now: Date): CatalogInsertable {
  return catalogInsertable(p, now);
}

/** X2's one product text: `<name>, <price>` then the link on its own line. Throws on a product it cannot state. */
export function railComposeProductInsert(p: RailProductRecord): { readonly text: string; readonly factRef: string } {
  return composeProductInsert(p);
}

/** X2's `CatalogMedia` with the id, and with the freshness the rail always checks. */
export interface RailMediaRecord extends CatalogMedia {
  readonly id: string;
  readonly fetchedAt: Date;
  readonly ttlSeconds: number;
}

export function railMediaInsertable(asset: RailMediaRecord, threadContactId: string, now: Date): MediaInsertable {
  return mediaInsertable(asset, threadContactId, now);
}
